import { InputNumber } from 'antd';
import type { InputNumberRef } from 'rc-input-number';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as St from './InputBoxCustom.styles';

import { UNIT_MEASURE } from '~/core/constants';
import formatUOM from '~/core/helpers/formatUOM';
import { ArrowInfo } from '~/core/models';
import { handleDecimalNumberInput } from '~/core/utils';

interface InputBoxCustomProps {
  arrowInfo: ArrowInfo;
  size: number;
  onUpdatedValue: (value: number) => void;
}

const InputBoxCustom = ({
  arrowInfo,
  size,
  onUpdatedValue,
}: InputBoxCustomProps) => {
  const [dimension, setDimension] = useState(0);
  const inputElement = useRef<InputNumberRef>(null);

  const { t } = useTranslation();

  useEffect(() => {
    // this catches the case where an out of range value was entered and constrained twice in a row
    // otherwise, the invalid value will show in the input
    const actualSize =
      arrowInfo.size && arrowInfo.size !== size ? arrowInfo.size : size;

    setDimension(actualSize);
  }, [arrowInfo, size]);

  return (
    <St.Container>
      <St.Description>
        {t('SCROLLABLE_AREA.COUNTERTOP.LENGTH')}&nbsp;(
        {formatUOM(UNIT_MEASURE.SIDE_WALLS)})
      </St.Description>
      <InputNumber
        ref={inputElement}
        value={dimension}
        onChange={(value) => setDimension(value ?? dimension)}
        onKeyDown={handleDecimalNumberInput}
        onPressEnter={() => inputElement.current?.blur()}
        onBlur={() => {
          if (dimension !== size) {
            onUpdatedValue(dimension);
          }
        }}
      />
    </St.Container>
  );
};

export default InputBoxCustom;
